export * from '@egovsolutions/angular-egov-api/front-end-state/common';
import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import * as i1 from '@egovsolutions/angular-egov-api/common';

class FrontEndNetworkService {
    constructor(
    // Dependencies
    api) {
        this.api = api;
    }
    loadState$() {
        return this.api.request$({ endpoint: 'status/APP' }).pipe(map(r => r.APP));
    }
}
FrontEndNetworkService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: FrontEndNetworkService, deps: [{ token: i1.EgovAPI }], target: i0.ɵɵFactoryTarget.Injectable });
FrontEndNetworkService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: FrontEndNetworkService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: FrontEndNetworkService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1.EgovAPI }]; } });

/**
 * Generated bundle index. Do not edit.
 */

export { FrontEndNetworkService };
